import { gql } from '@apollo/client';

export default gql`
  query getAllUsers {
    getAllUsers {
      ok
      error
      data {
        _id
        branch
        type
        username
        name
        email
        phone
        avatar
        address
        color
        lang
        tel
        fax
        mob

        isSuperAdmin
        isAdmin
        isBranchsAdmin
        isBranchAdmin
        isAccountant
        isDepartAdmin
        isEmployee
        isFinance
        isOperate
        isPurchase
        isAdmin
        isEditor
        isWriter
        isViewer

        roles
        newroles
        title

        company {
          _id
          basename
          foundationId

          packId
          packMonths
          packName
          packStart
          packEnd
          packCost
          packDiscount
          status

          name
          nameAr
          logo
          tel1
          tel2
          fax
          mob
          email
          website
          address

          userId
          username
          note

          createdAt
          updatedAt
        }

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeePhone
        employeeColor

        block
        themeId
        verified

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
